/* tslint:disable */
/* eslint-disable */
/**
 * gremiumhub
 * A platform for digital applications, approvals and discussions.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: denis.lugowski@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { NotificationType } from './NotificationType';
import {
    NotificationTypeFromJSON,
    NotificationTypeFromJSONTyped,
    NotificationTypeToJSON,
    NotificationTypeToJSONTyped,
} from './NotificationType';

/**
 * 
 * @export
 * @interface CreateNotificationDto
 */
export interface CreateNotificationDto {
    /**
     * 
     * @type {string}
     * @memberof CreateNotificationDto
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof CreateNotificationDto
     */
    message: string;
    /**
     * 
     * @type {string}
     * @memberof CreateNotificationDto
     */
    clickTarget: string;
    /**
     * Keycloak ID of the recipient user. If not provided, notification will be role-based or organization-wide.
     * @type {string}
     * @memberof CreateNotificationDto
     */
    recipientId?: string | null;
    /**
     * List of roles to send notification to. If both recipientId and targetRoles are null, notification will be sent to all organization members.
     * @type {Array<string>}
     * @memberof CreateNotificationDto
     */
    targetRoles?: Array<string> | null;
    /**
     * Keycloak ID of user to exclude from receiving this notification (e.g., the action performer).
     * @type {string}
     * @memberof CreateNotificationDto
     */
    excludedUserId?: string | null;
    /**
     * 
     * @type {NotificationType}
     * @memberof CreateNotificationDto
     */
    type: NotificationType;
    /**
     * The organization ID for this notification
     * @type {string}
     * @memberof CreateNotificationDto
     */
    organizationId: string;
}



/**
 * Check if a given object implements the CreateNotificationDto interface.
 */
export function instanceOfCreateNotificationDto(value: object): value is CreateNotificationDto {
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    if (!('clickTarget' in value) || value['clickTarget'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('organizationId' in value) || value['organizationId'] === undefined) return false;
    return true;
}

export function CreateNotificationDtoFromJSON(json: any): CreateNotificationDto {
    return CreateNotificationDtoFromJSONTyped(json, false);
}

export function CreateNotificationDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateNotificationDto {
    if (json == null) {
        return json;
    }
    return {
        
        'title': json['title'],
        'message': json['message'],
        'clickTarget': json['clickTarget'],
        'recipientId': json['recipientId'] == null ? undefined : json['recipientId'],
        'targetRoles': json['targetRoles'] == null ? undefined : json['targetRoles'],
        'excludedUserId': json['excludedUserId'] == null ? undefined : json['excludedUserId'],
        'type': NotificationTypeFromJSON(json['type']),
        'organizationId': json['organizationId'],
    };
}

export function CreateNotificationDtoToJSON(json: any): CreateNotificationDto {
    return CreateNotificationDtoToJSONTyped(json, false);
}

export function CreateNotificationDtoToJSONTyped(value?: CreateNotificationDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'title': value['title'],
        'message': value['message'],
        'clickTarget': value['clickTarget'],
        'recipientId': value['recipientId'],
        'targetRoles': value['targetRoles'],
        'excludedUserId': value['excludedUserId'],
        'type': NotificationTypeToJSON(value['type']),
        'organizationId': value['organizationId'],
    };
}

